import { captureException } from '@playbookux/playbook-web-core';
import {
  abortUpload,
  completeUpload,
  initializeUpload,
  uploadPart,
} from '../services/video';

const CHUNK_SIZE = 5 * 1024 * 1024;

const slice = (file, start, end) => {
  let sliced = () => {};
  if (file.mozSlice) {
    sliced = file.mozSlice;
  } else if (file.webkitSlice) {
    sliced = file.webkitSlice;
  } else if (file.slice) {
    sliced = file.slice;
  }

  return sliced.bind(file)(start, end);
};

export const uploadVideo = async (sessionId, file, onProgress, onCompleted, onError, replace) => {
  let uploadId = null;
  const fileSize = file.size;

  let start = 0;

  try {
    ({ upload_id: uploadId } = await initializeUpload(sessionId, replace));

    const parts = [];
    let partNumber = 0;
    let totalBytesSent = 0;

    const sendChunk = async () => {
      let end = start + CHUNK_SIZE;
      if (fileSize - end < 0) {
        end = fileSize;
      }
      if (start >= end) {
        const { data } = await completeUpload(sessionId, uploadId, parts, replace);
        onCompleted(data);
        return;
      }

      const part = slice(file, start, end);
      partNumber += 1;

      const response = await uploadPart(
        sessionId,
        uploadId,
        partNumber,
        part,
        // onUploadProgress
        (progressEvent) => {
          const { loaded, total } = progressEvent;
          const percent = ((totalBytesSent + loaded) / fileSize) * 100;

          onProgress(percent);

          if (loaded === total) {
            totalBytesSent += total;
          }
        },
        replace,
      );

      parts.push({
        etag: response ?? response.etag,
        part_number: partNumber,
      });

      start += CHUNK_SIZE;
      await sendChunk();
    };

    await sendChunk();
  } catch (err) {
    captureException('UPLOAD_VIDEO_FAILED', err);
    abortUpload(sessionId, uploadId, replace);
    onError(err);
  }
};
